module.exports = __webpack_public_path__ + "static/media/group--clean-room--dark.26cbc97e.svg";